import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup,Form, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { ExcelService } from 'src/app/services/excel.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NewuserService } from 'src/app/services/newuser.service';
import { NotificationService } from 'src/app/services/notification-service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import swal from 'sweetalert2';


@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.scss']
})
export class NewUserComponent implements OnInit {
  data = [];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "FirstName",
    "LastName",
    "ContactNO",
    "Email",
    "CreatedOn",
    "status",
    "action"
  ];
  dataExcel: any = [];
  excelColumns: string[];
  searchform:FormGroup;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  unencryexport: boolean=false
  sessionDataString: any;
  constructor(
    private newuser:NewuserService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private excelService: ExcelService,
    private navigationService: NavigationService,
    private formBuilder :FormBuilder,
    private sharedsession:UserSessionService,
  ) { }

  ngOnInit(): void {
    this.sessionDataString = JSON.parse(
      localStorage.getItem(this.sharedsession.localStorageSessionKey)
  );
    if(this.sessionDataString.emailid=='manigandan.sr@xenovex.com' ||this.sessionDataString.emailid == 'pavithra.p@xenovex.com' ||this.sessionDataString.emailid == 'gunal@gmail.com' )
    this.unencryexport=true
  console.log(this.sessionDataString.emailid);
  
    this.gettabledata(null);
    this.searchform=this.formBuilder.group({
      SearchQuery:[null,Validators.required],
    })
  }

  gettabledata(data){
    this.newuser.getUsers(data).subscribe((result)=>{
      this.data=result;
      this.dataExcel=result;
    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.paginator=this.paginator;

    })
  }
  search(){
    console.log('Is form valid:', this.searchform.valid); // true or false
    console.log('Form value:', this.searchform.value);
    if(this.searchform.valid){
    let value=this.searchform.value;
    this.gettabledata(value)
    }

  }
  clearFilter(){
  this.gettabledata(null);
  this.searchform.reset();
  }

  deleteProduct(data){
    const txt = 'Are you sure want to Deactivate ' + data.firstName + ' ' + data.lastName + ' ?';
    const Yes = 'Yes';
    const No = 'No';
    swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FF3E30',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.newuser.deletePendingUser(data.id).subscribe((result) => {
          if (result) {
            this.toastr.showSuccess("Deleted Successfully");
            this.clearFilter()
          }
          else
            this.toastr.showError("Sorry, something went wrong!!");
        })
      }
    });

  }



  encryptionname(name: string): string {
    const nameParts = name.split(" ");
    let maskedName = nameParts.map(part => {
      if (part.length > 2) {
        return part.substring(0, 2) + 'xxx';
      } else {
        return part;
      }
    }).join(" ");
    return maskedName;
  }
  encryptionmobileno(name: string): string {
    const nameParts = name.split(" ");
    let maskedName = nameParts.map(part => {
      if (part.length > 5) {
        const first3 = part.substring(0, 3);
        const last2 = part.substring(part.length - 2);
        const maskedMiddle = 'x'.repeat(part.length - 5);
        return first3 + maskedMiddle + last2;
      } else {
        // For names 5 characters or less, just return as is or partially mask
        return part;
      }
    }).join(" ");
    return maskedName;
  }
  encryptionEmail(email: string): string {
    const [localPart, domainPart] = email.split("@");
    const maskedLocalPart = localPart.replace(/./g, 'x');
    return maskedLocalPart+'@'+domainPart;
  }
  



  exportAsXLSX(unencryexport): void {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "S.No",
        "First Name",
        "Last Name",
        "Contact No",
        "Email",
        "Reseller",
        "Sales Rep",
        "Status"
      ];
      exportData.forEach((a, index) => {
        let lastName = a.lastName;
        let maskedName = unencryexport? lastName:this.encryptionname(lastName);
        let contacno=a.mobileNumber;
        let mobileno =unencryexport? contacno:this.encryptionmobileno(contacno);
        let Email=a.email;
        let email = unencryexport? Email:this.encryptionEmail(Email);


        excelList.push({
          sno: ++index,
          "First Name":a.firstName,
          "Last Name":maskedName,
          "Contact No":mobileno,
          "Email":email,
          "Reseller":a.resellerCode,
          "Sales Rep":a.salesRepCode,
          "Status":a.userStatusTypeName
        });
      });
      this.excelService.exportAsExcelFile(excelList, "ManageUser_"+ (unencryexport ? "UnEncrypted_" : "") + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }
}
